export { default as CoreDictionaryBuilder } from './DictionaryBuilder';
